export default __webpack_public_path__ + "assets/models/9afce138ebda88f6171e5cfc910183aa.glb";